import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
    const [formStatus, setFormStatus] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        setFormStatus('Sending...');
        // Mock send
        setTimeout(() => {
            setFormStatus('Message Sent! We will get back to you soon.');
            e.target.reset();
        }, 1500);
    };

    return (
        <div className="contact-page">
            <div className="container">
                <div className="contact-wrapper">
                    <div className="contact-info">
                        <h1>Get in touch</h1>
                        <p>Have a question or need assistance with your listing? Our team is here to help you.</p>

                        <div className="info-cards">
                            <div className="info-card">
                                <div className="card-icon"><i className="fa-solid fa-location-dot" style={{ color: 'var(--color-accent)' }}></i></div>
                                <div>
                                    <h3>Our Office</h3>
                                    <p>123 High Level Road, Colombo 06, Sri Lanka</p>
                                </div>
                            </div>

                            <div className="info-card">
                                <div className="card-icon"><i className="fa-solid fa-phone" style={{ color: 'var(--color-accent)' }}></i></div>
                                <div>
                                    <h3>Call Us</h3>
                                    <p>+94 77 123 4567</p>
                                    <p>+94 11 234 5678</p>
                                </div>
                            </div>

                            <div className="info-card">
                                <div className="card-icon"><i className="fa-solid fa-envelope" style={{ color: 'var(--color-accent)' }}></i></div>
                                <div>
                                    <h3>Email Us</h3>
                                    <p>support@riyamaga.site</p>
                                    <p>info@riyamaga.site</p>
                                </div>
                            </div>
                        </div>

                        <div className="social-links">
                            <h3>Follow Us</h3>
                            <div className="links">
                                <a href="#" className="social-link">Facebook</a>
                                <a href="#" className="social-link">Instagram</a>
                                <a href="#" className="social-link">Twitter</a>
                            </div>
                        </div>
                    </div>

                    <div className="contact-form-container">
                        <form onSubmit={handleSubmit} className="contact-form">
                            <h2>Send us a message</h2>
                            <div className="form-group">
                                <label>Full Name</label>
                                <input type="text" placeholder="Your Name" required />
                            </div>
                            <div className="form-group">
                                <label>Email Address</label>
                                <input type="email" placeholder="email@example.com" required />
                            </div>
                            <div className="form-group">
                                <label>Subject</label>
                                <input type="text" placeholder="How can we help?" required />
                            </div>
                            <div className="form-group">
                                <label>Message</label>
                                <textarea rows="5" placeholder="Write your message here..." required></textarea>
                            </div>
                            <button type="submit" className="btn-send">Send Message</button>
                            {formStatus && <p className="status-message">{formStatus}</p>}
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
